// Impoart Packages
import React from 'react';
import { useTranslation } from 'react-i18next';

// Import Pages
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

export default function ExportExcel({ action, variables, setOpenVariable, automId }) {
  const { t } = useTranslation();
  const label = 'CONTENT.CONFIGURATION-FORM.CSV.';

  return (
    <>
      <div className="conf-field-container">
        <FieldLabel name={t(label + 'SOURCE')} is_required={true} />
        <VariablePicker action={action} inputName="sourceData" isRequired
          variables={variables} setOpenVariable={setOpenVariable} hideRequired={true} filter="data table" />
        <small className='conf-field-desc'><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t('CONTENT.CONFIGURATION-FORM.EXCEL.SAVE.FOLDER-PATH')} is_required={true} />
        <TextInput action={action} inputName="folderPath" setOpenVariable={setOpenVariable}
          variables={variables} isRequired displayName={t('CONTENT.CONFIGURATION-FORM.EXCEL.SAVE.FOLDER-PATH')} hideRequired={true} autom_id={automId} />
        <small className='conf-field-desc'><em>e.g.    C:\Autommate\test</em></small>
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + 'ASSIGN-VARIABLE')} is_required={false} />
        <VariablePicker action={action} inputName="assignToVariable"
          variables={variables} setOpenVariable={setOpenVariable} isRequired={false} hideRequired={true} filter="string" />
        <small className='conf-field-desc'><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
      </div>
    </>
  );
}